import {
  TransitTaskCarCategoryLimitFormDto,
  type TransitTaskCarCategoryLimitFormInterface
} from '@zaoblako/shared/modules/client/dtos/transit-task-car-category-limit/transit-task-car-category-limit-form.dto';

import { CarCategorySingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/car-category-single-select/car-category-single-select.component';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { TooltipModule } from 'primeng/tooltip';
import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef
} from '@angular/core';

@Component({
  standalone: true,
  selector: 'crm-transit-task-car-category-limits-entry-form',
  templateUrl: './transit-task-car-category-limits-entry-form.component.html',
  styleUrl: './transit-task-car-category-limits-entry-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CarCategorySingleSelectComponent,
    CommonModule,
    FormsModule,
    InputNumberModule,
    TooltipModule
  ]
})
export class TransitTaskCarCategoryLimitsEntryFormComponent {
  // Value input/output props

  /** Entry value */
  @Input() public value: TransitTaskCarCategoryLimitFormInterface = { category: null, limit: 1 };

  /** Entry value change trigger */
  @Output() public valueChange = new EventEmitter<TransitTaskCarCategoryLimitFormInterface>();

  /** Delete button click trigger */
  @Output() public onDeleteClick = new EventEmitter();

  /** Validation errors */
  public errors: Partial<Record<keyof TransitTaskCarCategoryLimitFormInterface, string>> = {};

  /** If any validation error ocurred */
  public hasErrors = false;

  public constructor(
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {}

  /**
   * Validate value
   *
   * @param countByCategoryIds Number of selected categories based on their identifiers (to check for duplicate categories)
   *
   * @returns Validation result (is value valid)
   */
  public validate(countByCategoryIds: Record<number, number>): boolean {
    this.errors = {};
    this.hasErrors = false;

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, error] = TransitTaskCarCategoryLimitFormDto.validateSyncSafe(this.value);

    // Handle form validation errors
    if (
      error?.validationErrors?.category ||
      error?.validationErrors?.category?.id ||
      error?.validationErrors?.limit
    ) {
      this.hasErrors = true;
      if (error.validationErrors.category?.id) {
        this.errors.category = error.validationErrors.category.id;
      } else if (error?.validationErrors?.category) {
        this.errors.category = error.validationErrors.category as string;
      }
      if (error.validationErrors.limit) {
        this.errors.limit = error.validationErrors.limit;
      }
      this.changeDetectorRef.markForCheck();

      return false;
    }

    // Handle duplicated categories error
    if (
      countByCategoryIds &&
      this.value.category?.id &&
      countByCategoryIds[this.value.category.id] &&
      countByCategoryIds[this.value.category.id] > 1
    ) {
      this.hasErrors = true;
      this.errors.category = 'Категории ТС не должны дублироваться';
      this.changeDetectorRef.markForCheck();

      return false;
    }

    this.changeDetectorRef.markForCheck();
    return true;
  }
}
